module.exports = __webpack_public_path__ + "media/images/client/favicons/apple-touch-icon-180x180-precomposed-3cf25a80fa0b219fcee5cc7772bfaee9.png";